import { createFileRoute } from '@tanstack/react-router'

import DetailApbnApbdPage from '@/components/pages/backoffice/_ktg-penyuluh/apbn-apbd/$apbnApbd/containers/DetailApbnApbdPage'

export const Route = createFileRoute('/_backoffice/ktg-penyuluh/apbn/$apbnId/')(
  {
    component: RouteComponent
  }
)

function RouteComponent() {
  const id = Route.useParams().apbnId
  return <DetailApbnApbdPage type="APBN" id={id} />
}
